'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { MediaQuery } from '@s7/base';
import { Group } from '@s7/layout';
import { IconButton, Typography } from '@s7/ui';
import { ActionItemIcon } from './ActionItemIcon.js';
import { useLinkOverride } from '../../../../../common/ResourceLink/LinkOverride.context.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var defaultButtonProps = {
    as: "a",
    size: "md1",
    variant: "white",
    textColor: "text.mediumHigh"
};
var defaultIconProps = {
    color: "text.medium"
};
var defaultHintProps = {
    size: "sm1",
    weight: 600,
    color: "text.tertiary"
};
var ActionItem = function(props) {
    var variant = props.variant, link = props.link, hint = props.hint, label = props.label, buttonProps = props.buttonProps, iconProps = props.iconProps, hintProps = props.hintProps, onClick = props.onClick, others = _object_without_properties_loose(props, [
        "variant",
        "link",
        "hint",
        "label",
        "buttonProps",
        "iconProps",
        "hintProps",
        "onClick"
    ]);
    var unpackLink = useLinkOverride();
    return /*#__PURE__*/ jsxs(Group, _extends({
        position: "apart"
    }, others, {
        children: [
            (label || variant) && /*#__PURE__*/ jsx(IconButton, _extends({}, defaultButtonProps, buttonProps, unpackLink(link), {
                leftSide: /*#__PURE__*/ jsx(ActionItemIcon, _extends({}, defaultIconProps, iconProps, {
                    variant: variant
                })),
                onClick: onClick,
                children: label
            })),
            hint && /*#__PURE__*/ jsx(MediaQuery, {
                query: "sm1.up",
                styles: {
                    display: "none"
                },
                children: /*#__PURE__*/ jsx(Typography, _extends({}, defaultHintProps, hintProps, {
                    children: hint
                }))
            })
        ]
    }));
};

export { ActionItem };
